import Select from "components/individual/SelectV4";
import React from "react";
import { useContext } from "react";
import { Label } from "structure/Document";
import { DirectoryContext } from "..";

export default function TypeSelect() {
  const hook = useContext(DirectoryContext);

  return (
    <div>
      <Label>Tipo</Label>
      <Select
        labelToDisplay="label"
        onChange={hook.setTypeCustomer}
        defaultSelected={{
          keyToCompare: "value",
          value: hook.type.value,
        
        }}
        options={async () => [
          {
            label: "Todos",
            value: -1,
          },
          {
            label: "Clientes",
            value: 1,
          },
          {
            label: "Proveedor",
            value: 2,
          },
        ]}
      />
    </div>
  );
}
